const ReportTabs = {
    Sites: "sites",
    AgentCount: "agentCount",
    Payments: "payments",
    CustomerCandidate: "CustomerCandidate",
    Plan: "Plan",
    Balance: "Balance",
};

export default ReportTabs;
